<img [src]="imagePath" *ngIf="imagePath">

<div *nzModalFooter>
  <button class="btn btn-theme btn-sm" (click)="destroyModal()">Cancel</button>
</div>
